export enum ToolName {
  Brush = 'brush',
  Eraser = 'eraser',
  Line = 'line',
  Rectangle = 'rectangle',
  Circle = 'circle',
  RectangularTriangle = 'rectangular triangle',
  IsoscelesTriangle = 'isosceles triangle',
  Highlighter = 'highlighter',
}
